/** @jsx isolateComponent */

import { css } from '@emotion/core';
import { ReactNode } from 'react';

import { isolateComponent } from '@zapier/common-utils';
import { Colors } from '@zapier/design-system-revenue/src/constants';

type Props = {
  children: ReactNode;
  title: string;
};

const headingCss = css`
  color: ${Colors.deepSpace};
  font-size: 1.2em;
  font-weight: 600;
  margin-bottom: 1em;
  margin-top: 2em;
  padding: 0;
`;

const sectionCss = css`
  margin-bottom: 2em;
`;

export const ChangePlanSection = (props: Props) => (
  <section css={sectionCss}>
    <h2 css={headingCss}>{props.title}</h2>
    {props.children}
  </section>
);
